import React from 'react';
import {inject, observer} from 'mobx-react';
import {
  Table, Form, Button
  , Input, Row, Col, Radio, Select
} from 'antd';
import {toJS} from 'mobx';
import AppDatasBody from '../util/AppDatasBody';
import Navigation from '../public/navigation';

const store = ['priceStore', 'initStore'];
const createForm = Form.create;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const Option = Select.Option;

@inject(...store)
@observer
class Price extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      titles: ["应用名称", "应用编号", "是否收费", "参考价", "行业", "应用类别", "浏览器兼容",
        "ec版本兼容", "数据库兼容", "获取次数（一个订单可能获取多次）", "详情描述"],
      columns: [
        {title: '应用编号', dataIndex: 'productNumber', key: 'productNumber', width: 100, fixed: 'left'},
        {title: '应用名称', dataIndex: 'productName', key: 'productName', width: 150, fixed: 'left'},
        {title: '行业', dataIndex: 'tradeName', key: 'tradeName'},
        {title: '应用类别', dataIndex: 'productTypeName', key: 'productTypeName'},
        {title: '浏览器兼容', dataIndex: 'inter', key: 'inter'},
        {title: 'ec版本兼容', dataIndex: 'ec', key: 'ec'},
        {title: '数据库兼容', dataIndex: 'database', key: 'database'},
        {title: '获取次数', dataIndex: 'downCount', key: 'downCount'},
        {title: '详情描述', dataIndex: 'productDesc', key: 'productDesc'},
      ],
      // isFreeOptions: [
      //   {label: '全部', value: '-1'},
      //   {label: '免费', value: '1'},
      //   {label: '收费', value: '0'},
      // ],
      ifFbOptions: [
        {label: '全部', value: '-1'},
        {label: '非标', value: '1'},
        {label: '标准', value: '0'},
      ]
    }
  }

  async componentWillUnmount() {
  }

  async componentDidMount() {
    const {priceStore} = this.props;
    await priceStore.getPriceInfoList();
  }

  render() {
    let {columns, ifFbOptions} = this.state;
    let {priceStore, location } = this.props;
    let {
      priceInfoList, page, getPriceInfoList, loading
      , routes, routing, setPage, setSearchValue
      , resetSearchValue, searchValue, auth, editPriceInfoList
      , setPriceInfoList, addAuth
    } = priceStore;
    const {
      productName, isFree, ifFb, productNumber
      , productPrice, productTypeName, tradeName, inter
      , ec, database
    } = searchValue;
    priceInfoList = toJS(priceInfoList);
    let scroll = priceInfoList.length > 0 ? {x: 1300} : {};
    const {getFieldDecorator, validateFields, resetFields} = this.props.form;
    const freeCol = {
        title: '是否收费', dataIndex: 'isFree', key: 'isFree',width: 100,
        render:(text,record) => {
          let hasRight = record.auth ? ( record.auth.admin || record.auth ? true : false) : false;
          return {
            children: hasRight ? (
              <Select value={text} className='price-table-select'
                      onChange={value => editPriceInfoList(record, {isFree: value})}>
                <Option value='0'>是</Option>
                <Option value='1'>否</Option>
              </Select>
            ) : (
              <span className='price-span-select'>{text === '0' ? '是' : '否'}</span>
            )
          }
        }
      };
    const priceCol = {
      title: '参考价(元)', dataIndex: 'productPrice', key: 'productPrice',width: 150,
      render:(text,record) => {
        let hasRight = record.auth ? ( record.auth.admin || record.auth ? true : false) : false;
        return {
          children:  hasRight ? (
            <div className='price-input'>
              <Input value={text}
                     onChange={e => setPriceInfoList(record,{productPrice: e.target.value})}
                     onPressEnter={e => editPriceInfoList(record,{productPrice:e.target.value})}
              />
            </div>
          ) : (
            <span>{text}</span>
          )
        }
      }
    };
    if(!columns.find(value => freeCol.key === value.key)) columns.splice(2,0,freeCol);
    if(!columns.find(value => priceCol.key === value.key)) columns.splice(3,0,priceCol);
    return (
      <div className='price'>
        <AppDatasBody location={location}>
          <Navigation datas={toJS(routes)} onClick={(obj) => {
            if (obj.path !== '/')
              routing.push({pathname: obj.path});
            else routing.push('/');
          }}/>
          <div className="cs-search-mylist">
            <Row>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>应用编号：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入应用编号' value={productNumber}
                         onChange={e => setSearchValue({productNumber: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>应用名称：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入应用名称' value={productName}
                         onChange={e => setSearchValue({productName: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Col span={19} offset={5}>
                  <Button type="primary"
                          style={{marginRight: 10}}
                          onClick={getPriceInfoList}>搜索</Button>
                  <Button type="ghost"
                          style={{marginRight: 10}}
                          onClick={() => resetSearchValue()}>重置</Button>
                  {!!localStorage.me ?
                    <Button type="primary" icon="download" loading={loading}
                            href={window.server + "/product/price/export"}>导出</Button>
                    : ''}
                </Col>
              </Col>
            </Row>
            <Row className='cs-search-mylist-single'>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>行业：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入行业' value={tradeName}
                         onChange={e => setSearchValue({tradeName: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>应用类型：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入应用类型' value={productTypeName}
                         onChange={e => setSearchValue({productTypeName: e.target.value})}/>
                </Col>
              </Col>
              {/*<Col span={8}>
                <Row>
                  <Col span={8} className='price-label'> <label>是否免费：</label></Col>
                  <Col span={16} className='price-content'>
                    <RadioGroup options={isFreeOptions} value={isFree}
                                onChange={e => setSearchValue({isFree: e.target.value})}/>
                  </Col>
                </Row>
              </Col>*/}
            </Row>
            <Row className='cs-search-mylist-single'>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>应用价格：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入应用价格' value={productPrice}
                         onChange={e => setSearchValue({productPrice: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>浏览器兼容：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入浏览器兼容' value={inter}
                         onChange={e => setSearchValue({inter: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Row>
                  <Col span={8} className='price-label'> <label>是否非标产品：</label></Col>
                  <Col span={16} className='price-content'>
                    <RadioGroup options={ifFbOptions} value={ifFb}
                                onChange={e => setSearchValue({ifFb: e.target.value})}/>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='cs-search-mylist-single'>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>ec兼容：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入ec兼容' value={ec}
                         onChange={e => setSearchValue({ec: e.target.value})}/>
                </Col>
              </Col>
              <Col span={8}>
                <Col span={8} className='price-label'> <label>数据库兼容：</label></Col>
                <Col span={14}>
                  <Input placeholder='请输入数据库兼容' value={database}
                         onChange={e => setSearchValue({database: e.target.value})}/>
                </Col>
              </Col>
              {
                auth && auth.admin && (
                  <Col span={8}>
                    <FormItem
                      label="权限设置"
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 14 }}>
                      {getFieldDecorator('tel', {
                        rules: [{ required: true, message: '请输入手机号!' },{pattern: /^1[0-9]{10}$/,message: '请输入正确的手机号！'}],
                      })(
                        <Input placeholder='请输入手机号码' onPressEnter = {(e) => {
                          e.preventDefault();
                          validateFields((errors, values) => {
                            if (!!errors) {
                              return;
                            }
                            addAuth(values);
                            resetFields();
                          });
                        }}/>
                      )}
                    </FormItem>
                  </Col>
                )
              }
            </Row>
          </div>
          <Table columns={columns}
                 dataSource={priceInfoList}
                 loading={loading}
                 className='list-table'
                 scroll={scroll}
                 pagination={{
                   current: page.current,
                   pageSize: page.pageSize,
                   total: page.total,
                   showSizeChanger: true,
                   showQuickJumper: true,
                   onChange: (pageNum, pageSize) => {
                     setPage({current: pageNum, pageSize: pageSize});
                     getPriceInfoList();
                   },
                   onShowSizeChange: (current, size) => {
                     setPage({current: 1, pageSize: size});
                     getPriceInfoList();
                   }
                 }}
          />
        </AppDatasBody>
      </div>
    );
  }
}

Price = createForm()(Price);
export default Price;


// WEBPACK FOOTER //
// ./src/components/price/Price.js